import { Button } from "@/components/ui/button";
import { WifiOff } from "lucide-react";

// Stato chiaro dopo un salvataggio dall'esito sconosciuto: verifica sul server o riprova senza creare duplicati.
export default function SaveIssueBanner({ issue, onVerify, onRetry, testid = "save-issue" }) {
  if (!issue) return null;
  return (
    <div className="border border-amber-300 bg-amber-50 rounded-md p-3 text-sm flex flex-wrap items-center gap-3" data-testid={testid}>
      <WifiOff className="w-4 h-4 text-amber-700 shrink-0" />
      <div className="flex-1 min-w-[200px]">
        <div className="font-medium text-amber-900" data-testid={`${testid}-title`}>{issue.title || "Connessione interrotta: esito del salvataggio non confermato"}</div>
        <div className="text-xs text-amber-800" data-testid={`${testid}-message`}>{issue.message || "I dati compilati sono conservati. Verifica se la registrazione è arrivata, oppure riprova: non verrà creato un doppione."}</div>
      </div>
      <Button size="sm" variant="outline" onClick={onVerify} data-testid={`${testid}-verify`}>Verifica salvataggio</Button>
      <Button size="sm" className="bg-black hover:bg-zinc-800" onClick={onRetry} data-testid={`${testid}-retry`}>Riprova</Button>
    </div>
  );
}
